module.exports = __webpack_public_path__ + "static/img/img11.b65e90c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img11.png
// module id = cB7A
// module chunks = 1